import React from "react";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import {getManager} from "../../../ts/manager/Manager";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import AppButton from "../../element/button/AppButton";


interface ILink
{
    name: string;
    href: string;
    key: string;
}

interface IProps extends IRouteProps
{
    hidden:boolean
}


const NavBreadcrumbStructure = (props:IProps) =>
{
    let links: ILink[] = [];

    const choiceList: RouteChoice[] = [];
    const choice = props.choice;
    for (let i = 0; i < getManager().navigation.model.levelList.length; i++)
    {
        const levelChoice = getManager().navigation.model.levelList[i].choice;
        if(!levelChoice){
            continue;
        }
        if (!getManager().view.isSecondaryChoiceRoute(levelChoice))
        {
            choiceList.push(levelChoice)
        }
        if(levelChoice.id === choice.id){
            break;
        }
    }
    if (choiceList.length > 1 || (choiceList.length === 1 && choiceList[0].getHref() !== "/"))
    {
        links.push({
            name: "Home",
            href: "/",
            key: "/"
        })
        for (let i = 0; i < choiceList.length - 1; i++)
        {
            const choice = choiceList[i];
            if (choice.factoryID === "browse_route")
            {
              //  continue;
            }
            links.push({
                name: choice.name,
                href: choice.getHref(),
                key: choice.realPath
            })
        }
    }
    const hidden = props.hidden || !links.length;

    return <>


        <nav className={"breadcrumb-wrapper mt-3 " + (hidden ? " appear-hidden" : "")} aria-label="Breadcrumb">


            <ul className="horizontal-piped">

                {links.map((link) =>
                {
                    return <li key={link.key}>
                        <AppButton
                            href={link.href}
                        >
                            {link.name}
                        </AppButton>
                    </li>
                })}


            </ul>
        </nav>
    </>
}

export default NavBreadcrumbStructure;